import styled, { keyframes } from "styled-components";

export const fade = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const MainPageContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 1fr;
  grid-template-rows: 460px min-content min-content;
  column-gap: 20px;
  row-gap: 24px;

  @media (max-width: 1400px) {
    grid-template-columns: minmax(0, 1fr);
    column-gap: 0;
  }

  @media (min-width: 900px) {
    row-gap: 48px;
  }

  padding-bottom: 36px;
  animation: ${fade} 500ms forwards;
`;

export const PodcastsListWrapper = styled.div`
  grid-column: ${({ fullWidth }) => (fullWidth ? "1 / 3" : "1 / 2")};
  @media (max-width: 1652px) {
    grid-column: 1 / 3;
  }
`;
export const ReleasesListWrapper = styled.div`
  @media (max-width: 1652px) {
    grid-column: 1 / 3;
  }
`;
